import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Icon } from '../components/Icon.jsx';

const DATUM = new Intl.DateTimeFormat('de-CH', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

/**
 * Freigabe einer Modulanfrage durch ki|partner – geöffnet über den Link in der Teams-Karte, ohne Anmeldung.
 * Der Link legt fest, ob freigeschaltet oder abgelehnt wird; bestätigt wird hier mit einem Tipp.
 */
export function Freigabe() {
  const token = new URLSearchParams(window.location.search).get('t') ?? '';
  const q = useQuery({ queryKey: ['freigabe', token], queryFn: () => api(`/freigabe?t=${encodeURIComponent(token)}`), retry: false, staleTime: Infinity });
  const [antwort, setAntwort] = useState('');
  const [busy, setBusy] = useState(false);
  const [fehler, setFehler] = useState('');
  const [fertig, setFertig] = useState(null);
  const d = q.data;
  const an = d?.aktion === 'an';

  const ausfuehren = async () => {
    setBusy(true);
    setFehler('');
    try {
      setFertig(await api('/freigabe', { method: 'POST', body: { t: token, antwort } }));
    } catch (err) {
      setFehler(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login-card">
        <span className="login-logo"><Icon name="marke" size={30} stroke={2.6} /></span>
        <h1 className="h1">Modulanfrage</h1>
        {!d && !q.isError && <div className="skeleton" style={{ height: 120 }} />}
        {q.isError && <div className="notice err" role="alert">{q.error.message}</div>}
        {fertig && (
          <div className="notice info" role="status">
            <Icon name="check" size={18} />
            {fertig.status === 'an' ? `${fertig.modul.titel} ist für ${fertig.firma} freigeschaltet.` : `Anfrage von ${fertig.firma} für ${fertig.modul.titel} abgelehnt.`}
          </div>
        )}
        {d && !fertig && (
          <>
            <div className="stack" style={{ gap: 6 }}>
              <span style={{ fontSize: 18, fontWeight: 800 }}>{d.modul.titel}</span>
              <span className="sub">{d.firma} · Preis: {d.modul.preis}</span>
              {d.anfrage && <span className="sub">Beantragt von {d.anfrage.von}, {DATUM.format(new Date(d.anfrage.seit))}</span>}
              {d.anfrage?.nachricht && <span style={{ fontSize: 15 }}>«{d.anfrage.nachricht}»</span>}
            </div>
            {!d.offen && <div className="notice" role="status">Diese Anfrage ist bereits erledigt oder wurde zurückgezogen{d.erledigt ? ` (Stand: ${d.erledigt.status === 'an' ? 'freigeschaltet' : d.erledigt.status})` : ''}.</div>}
            {d.offen && (
              <>
                <label className="field">
                  <span className="label">{an ? 'Nachricht an die Firma (freiwillig)' : 'Begründung für die Firma'}</span>
                  <textarea className="input" rows={3} maxLength={500} value={antwort} onChange={(e) => setAntwort(e.target.value)} />
                </label>
                {fehler && <div className="notice err" role="alert">{fehler}</div>}
                <button type="button" className={`btn lg block${an ? '' : ' secondary'}`} disabled={busy} onClick={ausfuehren}>
                  {busy ? 'Speichert …' : an ? `Für ${d.firma} freischalten` : 'Anfrage ablehnen'}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
